<template>
  <div class="q_mar_b100px">
    <van-cell center is-link class="q_mar_t40px" @click="goToPersinfo()">
      <template>
        <div class="q_vertical_left">
          <!--          <img v-if="user.avatar == ''" src="@/assets/image/defimg.png" style="width: 15vw;height: 15vw;"/>-->
          <!--          <van-image v-if="user.avatar != ''" width="15vw" height="15vw" fit="cover" :src="user.avatar"/>-->
          <van-image width="15vw" height="15vw" fit="cover" :src="convertImg(user.avatar)"/>
          <div class="q_inlineblock q_mar_l15px">
            <div class="q_vertical_left">
              <span class="q_text_l q_bold" v-text="user.nickName">张三</span>
              <!-- 图片为加入的协会logo，显示用户已经加入的协会 -->
              <van-image width="5vw" height="5vw" fit="cover" v-for="item in deptList" :key="item.id"
                         :src="convertImg(item.pic)" style="margin-left: 2vw;"/>
              <!--              <van-image width="5vw" height="5vw" fit="cover"-->
              <!--                         :src="require('@/assets/image/banner.png')" style="margin-left: 2vw;"/>-->
            </div>
            <div class="q_text_s q_color_gray" v-text="user.phone">136****5984</div>
          </div>
        </div>
      </template>
    </van-cell>
    <div class="q_pad_lr15px q_mar_b10px">
      <van-row class="q_bor_bottom q_pad_b20px">
        <van-col span="8">
          <p class="q_text_xxl q_bold q_center q_mar_t20px" v-text="applyCount">2</p>
          <p class="q_text_m q_center q_mar_t5px">正在报名</p>
        </van-col>
        <van-col span="8">
          <p class="q_text_xxl q_bold q_center q_mar_t20px" v-text="toStartCount">2</p>
          <p class="q_text_m q_center q_mar_t5px">即将开始</p>
        </van-col>
        <van-col span="8">
          <p class="q_text_xxl q_bold q_center q_mar_t20px" v-text="totalCount">2</p>
          <p class="q_text_m q_center q_mar_t5px">历史参与</p>
        </van-col>
      </van-row>
      <!-- 去完善的块在基础资料和身份认证同时未完成时出现 -->
      <div class="q_mar_t20px q_po_re q_perf" style="width: 100%;" @click="goToBasicdata()"
           v-if="user.baseAudit==null">
        <van-image class="q_perfect" fit="cover" :src="require('@/assets/image/mine_tit.png')"/>
        <div class="q_pad_lr15px">
          <div class="q_inlineblock q_vertical_left q_mar_t30px">
            <img src="@/assets/image/over.png" style="width: 5vw;height: 5vw;"/>
            <span class="q_text_l q_bold q_mar_l10px q_color_white q_inlineblock">您的资料还未完善</span>
          </div>
          <div class="q_flo_right q_text_s q_color_white q_mar_t30px">去完善</div>
        </div>
      </div>
    </div>
    <van-cell center is-link class="q_home_icon" @click="goToBasicd()"
              v-if="user.baseAudit!=null">
      <template>
        <div class="q_vertical_left">
          <van-image fit="cover" :src="require('@/assets/image/m_jczl.png')"/>
          <div class="q_inlineblock q_mar_l10px">基础资料</div>
        </div>
      </template>
    </van-cell>
    <!--    <van-cell center is-link class="q_home_icon" @click="goToIdent()"-->
    <!--              v-if="user.baseAudit!=null&&user.idCardAudit!=null">-->
    <!--      <template>-->
    <!--        <div class="q_vertical_left">-->
    <!--          <van-image fit="cover" :src="require('@/assets/image/m_sfrz.png')"/>-->
    <!--          <div class="q_inlineblock q_mar_l10px">身份认证</div>-->
    <!--        </div>-->
    <!--      </template>-->
    <!--    </van-cell>-->
    <van-cell center is-link class="q_home_icon" @click="goToJoin()" v-if="user.baseAudit!=null">
      <template>
        <div class="q_vertical_left">
          <van-image fit="cover" :src="require('@/assets/image/m_wdxh.png')"/>
          <div class="q_inlineblock q_mar_l10px">我的中队</div>
        </div>
      </template>
    </van-cell>
    <van-cell center is-link class="q_home_icon" @click="goToMysign()" v-if="user.baseAudit!=null">
      <template>
        <div class="q_vertical_left">
          <van-image fit="cover" :src="require('@/assets/image/m_wdbm.png')"/>
          <div class="q_inlineblock q_mar_l10px">我的报名</div>
        </div>
      </template>
    </van-cell>
    <van-cell center is-link class="q_home_icon" @click="goToMyexchange()" v-if="user.baseAudit!=null">
      <template>
        <div class="q_vertical_left">
          <van-image fit="cover" :src="require('@/assets/image/m_wddh.png')" v-if="user.baseAudit!=null"/>
          <div class="q_inlineblock q_mar_l10px">我的兑换</div>
        </div>
      </template>
    </van-cell>
    <van-cell center is-link class="q_home_icon" @click="goToMyintegral()" v-if="user.baseAudit!=null">
      <template>
        <div class="q_vertical_left">
          <van-image fit="cover" :src="require('@/assets/image/m_wdjf.png')"/>
          <div class="q_inlineblock q_mar_l10px">我的积分</div>
        </div>
      </template>
    </van-cell>
    <van-cell center is-link class="q_home_icon" @click="goToMyspeed()" v-if="user.baseAudit!=null">
      <template>
        <div class="q_vertical_left">
          <van-image fit="cover" :src="require('@/assets/image/m_mjjl.png')"/>
          <div class="q_inlineblock q_mar_l10px">募捐记录</div>
        </div>
      </template>
    </van-cell>
    <van-cell center is-link class="q_home_icon" @click="goToApplyCertificate()" v-if="user.baseAudit!=null">
      <template>
        <div class="q_vertical_left">
          <van-image fit="cover" :src="require('@/assets/image/m_wdzs.png')"/>
          <div class="q_inlineblock q_mar_l10px">申请证书</div>
        </div>
      </template>
    </van-cell>
    <van-cell center is-link class="q_home_icon" @click="goToMyformal()" v-if="user.baseAudit!=null">
      <template>
        <div class="q_vertical_left">
          <van-image fit="cover" :src="require('@/assets/image/zs.png')"/>
          <div class="q_inlineblock q_mar_l10px">我的证书</div>
        </div>
      </template>
    </van-cell>
    <van-cell center is-link class="q_home_icon" @click="goToService()" v-if="user.baseAudit!=null">
      <template>
        <div class="q_vertical_left">
          <van-image fit="cover" :src="require('@/assets/image/m_fwjl.png')"/>
          <div class="q_inlineblock q_mar_l10px">服务记录</div>
        </div>
      </template>
    </van-cell>
    <van-cell center is-link class="q_home_icon" @click="refreshBank()"
              v-if="user.isBankAuth=='1'">
      <template>
        <div class="q_vertical_left">
          <van-image fit="cover" :src="require('@/assets/image/nyyh.png')"/>
          <div class="q_inlineblock q_mar_l10px">刷新网银认证信息</div>
        </div>
      </template>
    </van-cell>
<!--    <van-cell center is-link class="q_home_icon" @click="toLinkVolunteer()">-->
<!--      <template>-->
<!--        <div class="q_vertical_left">-->
<!--          <van-image fit="cover" :src="require('@/assets/image/zyy.png')"/>-->
<!--          <div class="q_inlineblock q_mar_l10px">我的志愿云</div>-->
<!--        </div>-->
<!--      </template>-->
<!--    </van-cell>-->
<!--    <van-cell center is-link class="q_home_icon" @click="toLinkChineseVolunteer()">-->
<!--      <template>-->
<!--        <div class="q_vertical_left">-->
<!--          <van-image fit="cover" :src="require('@/assets/image/zyy.png')"/>-->
<!--          <div class="q_inlineblock q_mar_l10px">中国志愿</div>-->
<!--        </div>-->
<!--      </template>-->
<!--    </van-cell>-->
<!--    <van-cell center is-link class="q_home_icon" @click="toWeApp()">-->
<!--      <template>-->
<!--        <div class="q_vertical_left">-->
<!--          <van-image fit="cover" :src="require('@/assets/image/zyy.png')"/>-->
<!--          <div class="q_inlineblock q_mar_l10px">志愿云小程序</div>-->
<!--        </div>-->
<!--      </template>-->
<!--    </van-cell>-->

    <!--    <van-cell center is-link class="q_home_icon" @click="goToSteup()">-->
    <!--      <template>-->
    <!--        <div class="q_vertical_left">-->
    <!--          <van-image fit="cover" :src="require('@/assets/image/m_xtsz.png')"/>-->
    <!--          <div class="q_inlineblock q_mar_l10px">系统设置</div>-->
    <!--        </div>-->
    <!--      </template>-->
    <!--    </van-cell>-->

  </div>
</template>

<script>
import {MelistJoin} from "@/api/join";
import {getRefreshBankUrl, getUserJoinInfo} from "@/api/user";
import {wxCloseShare} from "@/utils/jiutang";

export default {
  name: 'Mine',
  props: {
    msg: String
  },
  data() {
    return {
      user: {},
      deptList: [],
      applyCount: 0,
      toStartCount: 0,
      totalCount: 0
    }
  },
  created() {
    wxCloseShare()
    this.$modal.loading('加载个人信息')
    this.$store.dispatch("GetInfo").then(res => {
      this.user = res.data
    }).then(() => {
      let param = {userId: this.user.id}
      // 我的协会列表
      return MelistJoin(param)
    }).then(res => {
      this.deptList = res.rows
      // 获取活动参与信息
      return getUserJoinInfo()
    }).then(res => {
      this.applyCount = res.data.applyCount
      this.toStartCount = res.data.toStartCount
      this.totalCount = res.data.totalCount
    }).finally(() => {
      this.$modal.closeLoading()
    })
  },
  methods: {
    /**
     * 去完善
     */
    goToBasicdata() {
      //基本信息通过、身份证未通过
      // if ((this.user.baseAudit != null && this.user.baseAudit.auditState == 1) && (this.user.idCardAudit == null || this.user.idCardAudit.auditState == 0 || this.user.idCardAudit.auditState == 2)) {
      //   this.$router.push({
      //     path: '/mine/Identity'
      //   });
      // } else {
      //   this.$router.push({
      //     path: '/mine/Basicdata'
      //   });
      // }
      this.$router.push({
        path: '/mine/Basicdata'
      });
    },
    goToBasicd() {
      this.$router.push({
        path: '/mine/Basicd'
      });
    },
    goToIdent() {
      this.$router.push({
        path: '/mine/Ident'
      });
    },
    goToJoin() {
      this.$router.push({
        path: '/home/MeJoin'
      });
    },
    goToMysign() {
      this.$router.push({
        path: '/mine/Mysign'
      });
    },
    goToMyintegral() {
      this.$router.push({
        path: '/mine/Myintegral'
      });
    },
    goToMyexchange() {
      this.$router.push({
        path: '/mine/Myexchange'
      });
    },
    goToService() {
      this.$router.push({
        path: '/mine/Service'
      });
    },
    goToMyspeed() {
      this.$router.push({
        path: '/mine/Myspeed'
      });
    },
    goToMyformal() {
      this.$router.push({
        path: '/mine/Myformal'
      });
    },
    /**
     * 申请证书
     */
    goToApplyCertificate() {
      this.$router.push({
        path: '/mine/ApplyCertificate'
      });
    },
    goToPersinfo() {
      this.$router.push({
        path: '/mine/Persinfo'
      });
    },
    goToSteup() {
      this.$router.push({
        path: '/mine/Steup'
      });
    },
    /**
     * 刷新网银认证
     */
    refreshBank() {
      let self = this
      this.$modal.confirm('确定要刷新网银认证信息吗？').then(() => {
        self.$modal.loading('跳转中')
        getRefreshBankUrl().then(res => {
          window.location.href = res.msg
        })
      })


    },
    toWeApp() {
      this.$router.push({
        path: '/mine/ToWeApp'
      });
    },
    /**
     *  跳转我的志願云
     */
    toLinkVolunteer() {
      window.open('https://www.zhiyuanyun.com', 'target');
    },
    /**
     *  跳转中国志愿
     */
    toLinkChineseVolunteer() {
      window.open('https://chinavolunteer.mca.gov.cn/nvsidfh5/', 'target');
    }
  },
}
</script>
<style scoped="scoped">
.q_perf {
  height: 75px;
}

.q_perfect {
  width: 345px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
}

>>> .q_mar_t40px.van-cell::after {
  border: none !important;
}

>>> .q_mar_t40px.van-cell .van-image__img {
  border-radius: 50%;
}

.q_home_icon .van-image {
  width: 14px;
  height: 14px;
}
</style>
